import React, { useEffect, useState } from "react";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { practiceApi } from "../lib/practiceApi";
import "./login.css";

export default function PaymentResult({ outcome }) {
  const sessionId = new URLSearchParams(window.location.search).get("session_id") || "";
  const [state, setState] = useState(outcome === "cancel" ? "cancel" : "checking");

  useEffect(() => {
    if (outcome === "cancel" || !sessionId) return;
    let attempts = 0;
    const timer = setInterval(async () => {
      attempts += 1;
      try {
        const result = await practiceApi(`/payments/status/${sessionId}`);
        if (result.payment_status === "paid") { setState("paid"); clearInterval(timer); return; }
        if (["failed", "expired"].includes(result.payment_status)) { setState("failed"); clearInterval(timer); return; }
      } catch (err) { setState("failed"); clearInterval(timer); return; }
      if (attempts >= 15) { setState("timeout"); clearInterval(timer); }
    }, 2000);
    return () => clearInterval(timer);
  }, [sessionId, outcome]);

  const messages = {
    checking: ["Verifica del pagamento in corso…", "Non chiudere questa pagina: stiamo confermando la transazione con Stripe."],
    paid: ["Pagamento completato", "ingego Pro è attivo: palette, logo e filigrana dello studio sono sbloccati."],
    failed: ["Pagamento non riuscito", "Non è stato addebitato nulla. Puoi riprovare dalle Impostazioni → Colori documenti."],
    timeout: ["Conferma in corso", "Stripe non ha ancora confermato il pagamento. Riapri le Impostazioni tra qualche minuto."],
    cancel: ["Pagamento annullato", "Nessun addebito effettuato. Il piano Standard resta attivo."],
  }[state];

  return <main className="legal-page" data-testid={`payment-${state}`}>
    <img src="/brand/ingego-logo.png" alt="ingego" />
    <h1 style={{ display: "flex", alignItems: "center", gap: 12 }}>
      {state === "paid" && <CheckCircle2 size={28} color="#2F7D5B" />}
      {["failed", "cancel"].includes(state) && <XCircle size={28} color="#B4231A" />}
      {["checking", "timeout"].includes(state) && <Loader2 size={26} className="spin" />}
      {messages[0]}
    </h1>
    <p>{messages[1]}</p>
    <a className="legal-back" href="/#/settings" data-testid="payment-back">Torna alle impostazioni</a>
  </main>;
}
